import {UseFormRegisterReturn} from "react-hook-form";
import React from "react";

type TextInputProps = {
    label: string;
    registered: UseFormRegisterReturn;
    disabled?: boolean | undefined;
    error?: string | undefined;
}

export function TextInput({label, registered, disabled = false, error = undefined}: TextInputProps) {
    return (
        <div className="w-full text-base items-center pb-2 text-black">
            <div className="flex items-center">
                <div className="w-1/3 text-right">
                    {label}
                </div>
                <div className="w-1/2 ml-4">
                    <input
                        className={`block w-full bg-white border border-gray-400 hover:border-atlantis-100 ` +
                            `p-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline ${disabled ? 'bg-gray-100 opacity-50 pointer-events-none' : ''}`}
                        autoComplete='off'
                        disabled={disabled}
                        {...registered}
                    />
                    {
                        error && (
                            <div className="text-red-700 text-left pt-1">
                                {error}
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
}
